import { guidEmpty } from "utils/guid-empty";

export class TabelaPrecosModel {
  constructor(
    public id: string = guidEmpty(),
    public nome: string = '',
  ) { }
}
